export default {
    show: 'Show',
    'archived': 'Archived',
    'revolved': 'Revolved',
    'locked': 'Locked',
    'active': 'Active',
    'no-$-financial-files': 'No {state} financial files',

    'revolved-to-$': 'Revolved to "{financialFile}"',
    "welcome": "Welcome",
    "there-is-no-financial-file-so-create-your-financial-file": "You haven't created any financial files yet. Start by creating your financial file now!",
    "create-financial-file": "Create Financial File",
    'did-not-create-any-financial-files': 'there isn`t any added financial files yet...',
}